import { render, staticRenderFns } from "./viewBoleto.vue?vue&type=template&id=68c8317b&scoped=true&"
import script from "./viewBoleto.vue?vue&type=script&lang=js&"
export * from "./viewBoleto.vue?vue&type=script&lang=js&"
import style0 from "./viewBoleto.vue?vue&type=style&index=0&id=68c8317b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c8317b",
  null
  
)

export default component.exports